import type { StyleConfig } from '@chakra-ui/theme-tools';

export const CheckboxStyles: StyleConfig = {
  defaultProps: {
    colorScheme: 'blue',
  },
};
